module.exports = __webpack_public_path__ + "static/media/times-up.0cdbfdba.mp3";